import React, { useState, useEffect } from 'react';
import Layouts from '../../layouts/Layouts';
import { IconTrash, IconRefresh, IconSearch, IconCalendarTime, IconReload, IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { http, getAuthorizationHeader } from '../../config/http';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import DetailItem from '../Modal/DetailItem';
import useKarat from '../features/useKarat';

const HistoriHapusBrankas = () => {
    const [histori, setHistori] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [openDetail, setOpenDetail] = useState(false);
    const [detailItem, setDetailItem] = useState(null);
    const [filterKategori, setFilterKategori] = useState('');
    const [filterJenis, setFilterJenis] = useState('');
    const [filterKarat, setFilterKarat] = useState([]);
    const [filterBerat, setFilterBerat] = useState('');
    
    const { karatOption } = useKarat();
    const [kategoriList, setKategoriList] = useState([]);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [pageInput, setPageInput] = useState('1');
    const itemsPerPage = 10;

    const selectionRange = {
        startDate: startDate || new Date(),
        endDate: endDate || new Date(),
        key: 'selection',
    };

    const handleSelectDate = (date) => {
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate);
    };

    const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
    const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

    const fetchHistori = async () => {
        setLoading(true);
        try {
            const response = await http.get('/item-deletions/brankas-toko/salah-input', {
                headers: { Authorization: getAuthorizationHeader() }
            });
            if (response.data.status) {
                const rawData = response.data.data;
                const items = Array.isArray(rawData)
                    ? rawData
                    : (Array.isArray(rawData?.data) ? rawData.data : []);
                setHistori(items);
            }
        } catch (error) {
            console.error('Error fetching histori:', error);
            toast.error('Gagal mengambil data histori penghapusan');
        } finally {
            setLoading(false);
        }
    };

    const fetchKategoriOptions = async () => {
        try {
            const res = await http.get(
                'kategori',
                { headers: { Authorization: getAuthorizationHeader() } }
            );
            if (Array.isArray(res.data)) {
                setKategoriList(res.data);
            } else if (res.data.status && Array.isArray(res.data.data)) {
                setKategoriList(res.data.data);
            }
        } catch (err) {
            console.error('Error fetching kategori:', err);
        }
    };

    const handleRowClick = (log) => {
        setDetailItem(log.item);
        setOpenDetail(true);
    };

    useEffect(() => {
        fetchHistori();
        fetchKategoriOptions();
    }, []);

    const handleSelectKarat = (val) => {
        if (filterKarat.includes(val)) {
            setFilterKarat(filterKarat.filter(item => item !== val));
        } else {
            setFilterKarat([...filterKarat, val]);
        }
    };

    const handleResetFilters = () => {
        setFilterKategori('');
        setFilterJenis('');
        setFilterKarat([]);
        setFilterBerat('');
        setSearchTerm('');
        setStartDate(null);
        setEndDate(null);
    };

    const historiList = Array.isArray(histori)
        ? histori
        : (Array.isArray(histori?.data) ? histori.data : []);

    const filteredHistori = historiList.filter((log) => {
        const itemCode = log.item?.kode_item?.toLowerCase() || '';
        const search = searchTerm.toLowerCase();
        const matchSearch = itemCode.includes(search);
        
        const matchKategori = filterKategori ? log.item?.jenis_kategori?.kategori?.nama_kategori === filterKategori : true;
        const matchJenis = filterJenis ? log.item?.jenis_kategori?.nama_jenis === filterJenis : true;
        const matchKarat = filterKarat.length > 0 ? filterKarat.includes(String(log.item?.karat)) : true;
        const matchBerat = filterBerat ? parseFloat(log.item?.berat) === parseFloat(filterBerat) : true;
        
        const logDateStr = moment(log.created_at).format('YYYY-MM-DD');
        let matchDate = true;
        if (startDate && endDate) {
            matchDate = moment(logDateStr).isBetween(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), undefined, '[]');
        }

        return matchSearch && matchKategori && matchJenis && matchKarat && matchBerat && matchDate;
    });

    useEffect(() => {
        setCurrentPage(1);
        setPageInput('1');
    }, [searchTerm, filterKategori, filterJenis, filterKarat, filterBerat, startDate, endDate]);

    const totalPages = Math.ceil(filteredHistori.length / itemsPerPage) || 1;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedHistori = filteredHistori.slice(startIndex, startIndex + itemsPerPage);

    const nextPage = () => {
        setCurrentPage(prev => {
            const next = Math.min(prev + 1, totalPages);
            setPageInput(String(next));
            return next;
        });
    };

    const prevPage = () => {
        setCurrentPage(prev => {
            const prevPageNum = Math.max(prev - 1, 1);
            setPageInput(String(prevPageNum));
            return prevPageNum;
        });
    };

    const handlePageInputChange = (e) => setPageInput(e.target.value);
    const jumpToPage = () => {
        let p = parseInt(pageInput);
        if (!isNaN(p) && p >= 1 && p <= totalPages) {
            setCurrentPage(p);
        } else {
            setPageInput(String(currentPage));
        }
    };
    const handlePageInputKeyDown = (e) => {
        if (e.key === 'Enter') jumpToPage();
    };

    return (
        <Layouts>
            <ToastContainer />
            <div className="bg-white dark:bg-slate-800 rounded-md shadow-sm border border-slate-200 dark:border-slate-700 p-4 sm:p-6 mb-8 min-h-[75vh]">
                {/* Filter Toolbar (Matches PermohonanPindahBrankas.jsx style) */}
                <div className="flex flex-wrap items-center gap-2 bg-slate-50/70 dark:bg-slate-700/30 p-3 rounded-md border border-slate-200/70 dark:border-slate-700 mb-6">
                    {/* Kategori Select */}
                    <select
                        value={filterKategori}
                        onChange={(e) => { setFilterKategori(e.target.value); setFilterJenis(''); }}
                        className="border border-slate-300 dark:border-slate-600 rounded-md px-3 py-1.5 text-xs text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-700 cursor-pointer outline-none focus:ring-2 focus:ring-amber-500"
                    >
                        <option value="">Kategori</option>
                        {kategoriList.map(kat => (
                            <option key={kat.id} value={kat.nama_kategori}>{kat.nama_kategori}</option>
                        ))}
                    </select>

                    {/* Jenis Kategori Select */}
                    {filterKategori && (
                        <select
                            value={filterJenis}
                            onChange={(e) => setFilterJenis(e.target.value)}
                            className="border border-slate-300 dark:border-slate-600 rounded-md px-3 py-1.5 text-xs text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-700 cursor-pointer outline-none focus:ring-2 focus:ring-amber-500"
                        >
                            <option value="">Jenis Kategori</option>
                            {kategoriList
                                .find(k => k.nama_kategori === filterKategori)?.jenis_kategori
                                ?.map(jenis => (
                                <option key={jenis.id} value={jenis.nama_jenis}>{jenis.nama_jenis}</option>
                            ))}
                        </select>
                    )}

                    {/* Karat Checkbox Dropdown */}
                    <div className="dropdown dropdown-bottom">
                        <div
                            tabIndex={0}
                            className="px-3 py-1.5 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 cursor-pointer hover:border-amber-400 hover:text-amber-500 transition-all duration-200 flex items-center gap-2 text-xs"
                        >
                            <span>
                                {filterKarat.length > 0 ? `Karat (${filterKarat.length})` : 'Karat'}
                            </span>
                        </div>
                        <div tabIndex={0} className="dropdown-content p-2 shadow-xl bg-white dark:bg-slate-800 rounded-md border border-slate-100 dark:border-slate-700 z-50 mt-1 w-52 grid grid-cols-2 gap-1 max-h-60 overflow-y-auto pr-1">
                            {karatOption.map((k) => (
                                <label key={k} className="flex items-center gap-2 cursor-pointer p-1.5 hover:bg-slate-50 dark:hover:bg-slate-700/50 rounded-md transition-colors">
                                    <input
                                        type="checkbox"
                                        className="checkbox checkbox-xs checkbox-warning rounded"
                                        checked={filterKarat.includes(k.toString()) || filterKarat.includes(k)}
                                        onChange={() => handleSelectKarat(k.toString())}
                                    />
                                    <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">{k}k</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Date Range Dropdown */}
                    <div className="dropdown dropdown-bottom">
                        <div
                            tabIndex={0}
                            className="px-3 py-1.5 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 cursor-pointer hover:border-amber-400 hover:text-amber-500 transition-all duration-200 flex items-center gap-2 text-xs"
                        >
                            <IconCalendarTime size={16} />
                            <span>
                                {startDate && endDate ? (awal === akhir ? awal : `${awal} - ${akhir}`) : 'Semua Tanggal'}
                            </span>
                        </div>
                        <div tabIndex={0} className="dropdown-content menu p-2 shadow-xl bg-white dark:bg-slate-800 rounded-md border border-slate-100 dark:border-slate-700 z-50 mt-1 right-0 sm:right-auto">
                            <DateRange ranges={[selectionRange]} onChange={handleSelectDate} />
                        </div>
                    </div>

                    {/* Cari Berat Input + Search Button */}
                    <div className="flex items-center gap-1.5 flex-1 min-w-[140px]">
                        <input
                            type="text"
                            placeholder="Cari Berat"
                            value={filterBerat}
                            onChange={(e) => setFilterBerat(e.target.value)}
                            className="w-full px-3 py-1.5 text-xs border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500"
                        />
                        <button
                            type="button"
                            className="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-md shadow-md transition-all flex items-center justify-center flex-shrink-0 cursor-default"
                            title="Filter by berat applies automatically"
                        >
                            <IconSearch size={16} />
                        </button>
                    </div>

                    {/* Quick Search Kode */}
                    <div className="relative flex-1 min-w-[140px]">
                        <input
                            type="text"
                            placeholder="Cari Kode Barang..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full px-3 py-1.5 text-xs border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500"
                        />
                    </div>

                    {/* Reset Filter Button */}
                    {(filterKategori || filterJenis || filterKarat.length > 0 || filterBerat || searchTerm || startDate || endDate) && (
                        <button
                            type="button"
                            onClick={handleResetFilters}
                            className="px-2.5 py-1.5 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-md transition-all"
                        >
                            Reload Filter
                        </button>
                    )}

                    <button
                        type="button"
                        onClick={fetchHistori}
                        className="px-2.5 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700/50 dark:hover:bg-slate-600 rounded-md text-slate-500 dark:text-slate-300 transition-all flex items-center justify-center"
                        title="Reload Data API"
                    >
                        <IconReload size={16} />
                    </button>
                </div>

                <div className="overflow-x-auto rounded-md border border-slate-200 dark:border-slate-700">
                    <table className="w-full text-left text-sm whitespace-nowrap">
                        <thead className="bg-slate-50 dark:bg-slate-800/50 text-slate-600 dark:text-slate-300 border-b border-slate-200 dark:border-slate-700">
                            <tr>
                                <th className="px-4 py-3 font-semibold text-center w-12">No.</th>
                                <th className="px-4 py-3 font-semibold">Waktu Hapus</th>
                                <th className="px-4 py-3 font-semibold">Tanggal Input</th>
                                <th className="px-4 py-3 font-semibold">Kode Barang</th>
                                <th className="px-4 py-3 font-semibold">Nama Barang</th>
                                <th className="px-4 py-3 font-semibold">Berat|Karat</th>
                                <th className="px-4 py-3 font-semibold">Alasan</th>
                                <th className="px-4 py-3 font-semibold">Dihapus Oleh</th>
                                <th className="px-4 py-3 font-semibold">Lokasi Cabang</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200 dark:divide-slate-700 text-slate-700 dark:text-slate-300">
                            {loading ? (
                                <tr>
                                    <td colSpan="9" className="px-4 py-8 text-center text-slate-500">
                                        Memuat data...
                                    </td>
                                </tr>
                            ) : filteredHistori.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="px-4 py-8 text-center text-slate-500">
                                        Tidak ada data histori penghapusan.
                                    </td>
                                </tr>
                            ) : (
                                paginatedHistori.map((log, index) => (
                                    <tr key={log.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors cursor-pointer" onClick={() => handleRowClick(log)}>
                                        <td className="px-4 py-3 text-center text-slate-500">{startIndex + index + 1}.</td>
                                        <td className="px-4 py-3 text-slate-500">
                                            {moment(log.created_at).format('DD/MM/YYYY HH:mm:ss') || '-'}
                                        </td>
                                        <td className="px-4 py-3 text-slate-500">
                                            {log.item?.created_at || '-'}
                                        </td>
                                        <td className="px-4 py-3 font-medium text-slate-900 dark:text-slate-100">
                                            {log.item?.kode_item || '-'}
                                        </td>
                                        <td className="px-4 py-3">
                                            {log.item?.jenis_kategori?.nama_jenis || '-'}
                                        </td>
                                        <td className="px-4 py-3">
                                            {log.item?.berat ? `${log.item.berat} gr | ${log.item?.karat ? `${log.item.karat} K` : ''}` : '-'}
                                        </td>
                                        <td className="px-4 py-3 text-slate-600 dark:text-slate-400 max-w-[200px] truncate" title={log.alasan}>
                                            {log.alasan || '-'}
                                        </td>
                                        <td className="px-4 py-3">
                                            {log.user?.name || '-'}
                                        </td>
                                        <td className="px-4 py-3">
                                            {log.cabang?.nama_cabang || '-'}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        {paginatedHistori.length > 0 && (
                            <tfoot className="bg-slate-50 dark:bg-slate-800/50 text-slate-700 dark:text-slate-300 border-t border-slate-200 dark:border-slate-700 font-bold">
                                <tr>
                                    <td colSpan="5" className="px-4 py-3 text-right">Total Berat (Halaman Ini):</td>
                                    <td colSpan="4" className="px-4 py-3 text-left">
                                        {paginatedHistori.reduce((acc, log) => acc + parseFloat(log.item?.berat || 0), 0).toFixed(2)} gr
                                    </td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                </div>

                {/* Pagination Footer */}
                {filteredHistori.length > 0 && (
                    <div className="flex items-center justify-end mt-6 gap-2.5">
                        <span className="text-xs font-medium text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                            Halaman
                            <input
                                type="text"
                                value={pageInput}
                                onChange={handlePageInputChange}
                                onBlur={jumpToPage}
                                onKeyDown={handlePageInputKeyDown}
                                className="w-12 h-7 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-400 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                            />
                            dari <span className="font-bold text-amber-700 dark:text-amber-400">{totalPages}</span>
                        </span>
                        <div className="flex items-center gap-1">
                            <button
                                onClick={prevPage}
                                disabled={currentPage < 2}
                                type="button"
                                className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                            >
                                <IconChevronLeft size={16} />
                            </button>
                            <button
                                onClick={nextPage}
                                disabled={currentPage >= totalPages}
                                type="button"
                                className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                            >
                                <IconChevronRight size={16} />
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <DetailItem openDetail={openDetail} closeModalDetail={() => setOpenDetail(false)} detailItem={detailItem} />
        </Layouts>
    );
};

export default HistoriHapusBrankas;
